// NOTE: The purpose of this function is to Add https prefix to inputUrl.

export const addHttpsPrefix = (inputUrl: string): string => {
  return 'https://' + inputUrl
}
